const { isPhoto, isResume } = require("../../utils/checkFiletype.js");

// function for upload screenshot
const previewFile = (vueObj, event) => {
  const input = event.target;

  if (input?.files[0]) {
    const size = input.files[0].size;
    const fileSizeInMb = size / (1024 * 1024);
    // Initialize error flags
    let sizeError = false;
    let typeError = false;
    // Check file size
    if (fileSizeInMb > 10) {
      sizeError = true;
    }
    vueObj.imagename = input.files[0].name;
    let reader = new FileReader();

    reader.readAsDataURL(input.files[0]);

    // FOR getting the extension of a particular file
    let parts = input.files[0].name.split(".");
    let ext = parts[parts.length - 1];
    vueObj.Candidate.imageMedia = ext;

    // Check if the fileType is valid
    if (isPhoto(vueObj.Candidate.imageMedia) === false) {
      typeError = true;
    }

    // Display errors
    if (sizeError && typeError) {
      // Display both errors
      vueObj.isFailed = true;
      vueObj.errorModal("File size should not exceed 10MB");
      vueObj.LoaderStatus = false;

      // Reset the input field, file, and imageMedia if needed
      input.value = ""; // Reset the file input
      vueObj.file = [];
      delete vueObj.Candidate.imageMedia;
    } else if (sizeError) {
      // Display only size error
      vueObj.errorModal("File size should not exceed 10MB");
      vueObj.LoaderStatus = false;
      // Reset the input field, file, and imageMedia if needed
      input.value = ""; // Reset the file input
      vueObj.file = [];
      delete vueObj.Candidate.imageMedia;
    } else if (typeError) {
      // Display only type error
      vueObj.isFailed = true;
      vueObj.checkMedia = false;
      vueObj.LoaderStatus = false;

      // Reset the input field, file, and imageMedia if needed
      input.value = ""; // Reset the file input
      vueObj.file = [];
      delete vueObj.Candidate.imageMedia;
    } else {
      // FOR storing the FILE OBJECT Copy of the uploaded FILE
      vueObj.checkMedia = true;
      vueObj.file = input.files[0];
      vueObj.isFailed = false;
      reader.onload = (e) => {
        // FOR storing the binary value of a FILE
        vueObj.Candidate.imageMedia = e.target.result;
        vueObj.$forceUpdate();
      };
    }
  }
};

// function for upload resume
const previewResume = (vueObj, event) => {
  let input = event.target;

  if (input?.files[0]) {
    const size = input.files[0].size;
    const fileSizeInMb = size / (1024 * 1024);

    // Initialize error flags
    let sizeError = false;
    let typeError = false;

    // Check file size
    if (fileSizeInMb > 10) {
      sizeError = true;
    }

    vueObj.resumename = input.files[0].name;
    let reader = new FileReader();
    reader.readAsDataURL(input.files[0]);
    // FOR getting the extension of a particular file
    let parts = input.files[0].name.split(".");
    let ext = parts[parts.length - 1];
    vueObj.Candidate.resume = ext;
    if (isResume(vueObj.Candidate.resume) === false) {
      typeError = true;
      vueObj.removeResume();
    }
    if (sizeError && typeError) {
      vueObj.resumefailed = true;
      vueObj.errorModal("File size should not exceed 10MB");
      vueObj.LoaderStatus = false;
      input.value = ""; // Reset the file input
      delete vueObj.Candidate.resume;
    } else if (sizeError) {
      vueObj.errorModal("File size should not exceed 10MB");
      vueObj.LoaderStatus = false;
      input.value = ""; // Reset the file input
      delete vueObj.Candidate.resume;
      return;
    } else if (typeError) {
      vueObj.resumefailed = true;
      vueObj.LoaderStatus = false;
      input.value = ""; // Reset the file input
      delete vueObj.Candidate.resume;
    } else {
      vueObj.checkMedia1 = true;
      vueObj.resumeFiles = input.files[0];

      vueObj.resumefailed = false;
      reader.onload = (e) => {
        vueObj.Candidate.resume = e.target.result;
        vueObj.$forceUpdate();
      };
    }
    vueObj.uploadResumes();
  }
};

const removePhoto = (vueObj) => {
  vueObj.Candidate.imageMedia = "";
  vueObj.file = [];
  vueObj.imagename = "";
  vueObj.checkMedia = false;
};
const removeResume = (vueObj) => {
  vueObj.resumeFiles = [];
  vueObj.Candidate.resume = "";
  vueObj.resumename = "";
  vueObj.checkMedia1 = false;
};

// toggle for b-form-select
const setOnClickListeners = (vueObj) => {
  // Get the DOM element with the id "source"
  const elem = document.getElementById("source");

  // Add a click event listener to toggle "sourceProfileToggle" when clicked
  elem.addEventListener("click", () => {
    vueObj.sourceProfileToggle = !vueObj.sourceProfileToggle;
  });

  // Add a keypress event listener to set "sourceProfileToggle" to true when a key is pressed
  elem.addEventListener("keypress", () => {
    vueObj.sourceProfileToggle = true;
  });

  // Add a blur event listener to set "sourceProfileToggle" to false when the element loses focus
  elem.addEventListener("blur", () => {
    vueObj.sourceProfileToggle = false;
  });

  // Repeat the above three steps for two more DOM elements: "noticePeriod" and "highestQualification"
  const elem1 = document.getElementById("noticePeriod");
  elem1.addEventListener("click", () => {
    vueObj.noticePeriodToggle = !vueObj.noticePeriodToggle;
  });
  elem1.addEventListener("keypress", () => {
    vueObj.noticePeriodToggle = true;
  });
  elem1.addEventListener("blur", () => {
    vueObj.noticePeriodToggle = false;
  });

  const elem2 = document.getElementById("highestQualification");
  elem2.addEventListener("click", () => {
    vueObj.highestQualificationToggle = !vueObj.highestQualificationToggle;
  });
  elem2.addEventListener("keypress", () => {
    vueObj.highestQualificationToggle = true;
  });
  elem2.addEventListener("blur", () => {
    vueObj.highestQualificationToggle = false;
  });
};

const emptyOtherNoticePeriod = (vueObj) => {
  if (
    vueObj.Candidate.source != "other" ||
    vueObj.Candidate.noticePeriod != "Others"
  ) {
    vueObj.othernoticePeriod = "";
    vueObj.$v.othernoticePeriod.$reset();
  }
};
const clearLocation = (vueObj) => {
  if (!vueObj.Candidate.willingToRelocate) {
    vueObj.searchreloc = "";
    vueObj.$v.searchreloc.$reset();
  }
};
const titleCase = (vueObj, str) => {
  // Use regular expression to insert a space before each uppercase letter
  return (
    str
      .replace(/([A-Z])/g, " $1")
      // Capitalize the first letter of each word
      .replace(/^./, (match) => match.toUpperCase())
  );
};
const checkSalary = (vueObj) => {
  if (vueObj.Candidate.currentCTC != "" && vueObj.Candidate.expectedCTC != "") {
    let min = parseFloat(vueObj.Candidate.currentCTC);
    let max = parseFloat(vueObj.Candidate.expectedCTC);
    if (!isNaN(min) && !isNaN(max)) {
      if (min <= max) {
        vueObj.salaryCheck = false;
      } else {
        vueObj.salaryCheck = true;
      }
    }
  } else {
    vueObj.salaryCheck = false;
  }
};

//router go back
const goBackPointer = (route, router) => {
  if (
    route.name == "AddCandidate" ||
    route.name == "AddCandidateInVendor" ||
    route.name == "AddCandidateInJD"
  ) {
    if (route.query.createdBy == "vendor") {
      router.push({
        name: "vendorCandidates",
        params: {
          jobID: route.query.jobID,
          customerID: route.query.customerID,
          title: route.query.title,
        },
      });
    } else if (route.name == "AddCandidateInJD") {
      router.push({
        name: "JdDetails",
        query: {
          jobID: route.query.jobID,
          jobTitle: route.query.jobTitle,
          customerID: route.query.customerID,
          cardName: route.query.cardName,
        },
      });
    } else {
      router.push({
        name: "TalentPool",
      });
    }
  } else if (
    route.name == "EditCandidate" ||
    route.name == "EditCandidateInVendor" ||
    route.name == "EditCandidateInJD"
  ) {
    if (route.query.createdBy == "vendor") {
      router.push({
        name: "vendorCandidates",
        params: {
          jobID: route.query.jobID,
          customerID: route.query.customerID,
          title: route.query.title,
        },
      });
    } else if (route.name == "EditCandidateInJD") {
      router.push({
        name: "JdDetails",
        query: {
          jobID: route.query.jobID,
          jobTitle: route.query.jobTitle,
          customerID: route.query.customerID,
          cardName: route.query.cardName,
          status: route.query.status,
        },
      });
    } else {
      router.push({
        name: "TalentPool",
      });
    }
  }
};
const continueAdd = (vueObj) => {
  vueObj.Candidate = vueObj.responsedata;
  vueObj.Candidate.jobID = "";
  vueObj.Candidate.customerID = "";
  vueObj.$bvModal.hide("addconfirm");
  vueObj.samePhoneNumber = false;
  vueObj.sameEmail = false;
};
const locationFunction = (vueObj) => {
  vueObj.loc = true;
  vueObj.$forceUpdate();
};

const relocationFunction = (vueObj) => {
  vueObj.reloc = true;
  vueObj.$forceUpdate();
};

const skillFunction = (vueObj) => {
  vueObj.skilltag = true;
  vueObj.$forceUpdate();
};

const removeExperienceLeadingZeros = (vueObj) => {
  vueObj.Candidate.experince = vueObj.Candidate.experince.replace(
    /^0+(?=[1-9])/,
    ""
  );
};

const removeCurrentLeadingZeros = (vueObj) => {
  vueObj.Candidate.currentCTC = vueObj.Candidate.currentCTC.replace(
    /^0+(?=[1-9])/,
    ""
  );
};

const removeExpectedLeadingZeros = (vueObj) => {
  vueObj.Candidate.expectedCTC = vueObj.Candidate.expectedCTC.replace(
    /^0+(?=[1-9])/,
    ""
  );
};

// document.body.addEventListener("keydown", NumbersOnly);

const NumbersOnly = (evt, type) => {
  if (evt.target.nodeName === "INPUT") {
    const charCode = evt.key;
    let value = type ? true : charCode !== ".";
    if ((charCode < "0" || charCode > "9") && value) {
      evt.preventDefault();
    } else {
      return true;
    }
  }
};

// document.body.addEventListener("keydown", restrictSpecialCharacters);

const restrictSpecialCharacters = (evt) => {
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
  const restrictedChars = ["$", "%", "^", "&", "*"];

  if (
    evt.target.nodeName === "INPUT" &&
    evt.target.type === "text" &&
    restrictedChars.includes(evt.key) &&
    !allowedKeys.includes(evt.key)
  ) {
    evt.preventDefault();
  }
};

// document.body.addEventListener("keydown", restrictCTCchars);

const restrictCTCchars = (evt) => {
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
  const restrictedChars = [
    "!",
    "@",
    "#",
    "$",
    "%",
    "^",
    "&",
    "*",
    "(",
    ")",
    "-",
    "+",
    ":",
    ";",
    "{",
    "}",
    "[",
    "]",
    "=",
    "_",
    "?",
    "<",
    ">",
  ];

  if (
    evt.target.nodeName === "INPUT" &&
    evt.target.type === "text" &&
    restrictedChars.includes(evt.key) &&
    !allowedKeys.includes(evt.key)
  ) {
    evt.preventDefault();
  }
};

const assignResumeAndImage = (vueObj) => {
  if (vueObj.Candidate.imageMedia) {
    let lastIndexImage = vueObj.Candidate.imageMedia.lastIndexOf("/");
    let someImage = vueObj.Candidate.imageMedia.substring(lastIndexImage + 1);
    vueObj.imagename = someImage.split("?")[0];
  }
  if (vueObj.Candidate.resume != null) {
    let lastIndex = vueObj.Candidate.resume.lastIndexOf("/");
    let some = vueObj.Candidate.resume.substring(lastIndex + 1);
    vueObj.resumename = some.split("?")[0];
  }
};

const locatingFunc = (vueObj) => {
  // Call Initial Data
  vueObj.searchLoc();
  vueObj.searchReLoc();
  vueObj.searchSkl();
  // Create the debounced versions of the searchSkl, searchLoc, and searchKey methods
  vueObj.debouncedSearchSkl = vueObj.debounce(vueObj.searchSkl, 500);
  vueObj.debouncedSearchLoc = vueObj.debounce(vueObj.searchLoc, 500);
  vueObj.debouncedSearchReLoc = vueObj.debounce(vueObj.searchReLoc, 500);

  // Wait for the document to be fully loaded
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      let a = document.getElementById("uploadResumes");
      let b = a.clientHeight;
      let c = parseInt(b) + parseInt(b);
      this.uploadheight = c + "px";
      document.querySelector('label[for="uploadcandResume"]').style.height =
        c + "px";

      let candimg = document.getElementById("uploadimage");
      let cimg = candimg.clientHeight;
      let candscreenshot = parseInt(cimg) + parseInt(cimg);
      this.uploadcandheight = candscreenshot + "px";
      document.querySelector('label[for="uploadcandimage"]').style.height =
        candscreenshot + "px";
    }, 10);
  });
};

module.exports = {
  previewFile,
  previewResume,
  removePhoto,
  removeResume,
  setOnClickListeners,
  emptyOtherNoticePeriod,
  clearLocation,
  titleCase,
  checkSalary,
  goBackPointer,
  continueAdd,
  locationFunction,
  relocationFunction,
  skillFunction,
  removeCurrentLeadingZeros,
  removeExpectedLeadingZeros,
  NumbersOnly,
  restrictSpecialCharacters,
  restrictCTCchars,
  assignResumeAndImage,
  locatingFunc,
  removeExperienceLeadingZeros,
};
